// extracted by mini-css-extract-plugin
export default {"hint":"_2SyAkDg2","sliders":"_1WVR4fC_"};